<div class="modal-header">
  <h4 class="modal-title">Mail Gönder</h4>
</div>

<div class="modal-body" tabindex="0" ngbAutofocus>
  <form [formGroup]="form">
    <label>Mail</label>
    <div class="form-group">
      <input type="email" id="mail" formControlName="mail" placeholder="Mail giriniz." class="form-control" />
      <div *ngIf="form.get('mail').touched && form.get('mail').invalid" class="text-danger">
        <small *ngIf="form.get('mail').errors?.required">Mail zorunludur.</small>
        <small *ngIf="form.get('mail').errors?.email">Geçerli bir mail adresi giriniz.</small>
      </div>
    </div>
    
    <label>Mail Başlığı</label>
    <div class="form-group">
      <input type="text" id="title" formControlName="title" placeholder="Mail başlığı giriniz." class="form-control" />
      <div *ngIf="form.get('title').touched && form.get('title').invalid" class="text-danger">
        <small *ngIf="form.get('title').errors?.required">Mail başlığı zorunludur.</small>
      </div>
    </div>

    <label>Mail Açıklaması</label>
    <div class="form-group">
      <input type="text" id="description" formControlName="description" placeholder="Mail açıklama giriniz." class="form-control" />
      <div *ngIf="form.get('description').touched && form.get('description').invalid" class="text-danger">
        <small *ngIf="form.get('description').errors?.required">Mail açıklaması zorunludur.</small>
      </div>
    </div>

    <label>Pdf Şablonu Seç</label>
    <div class="form-group">
      <ng-select [items]="pdfs" bindLabel="pdfTitle" bindValue="id" formControlName="pdfId"></ng-select>
      <div *ngIf="form.get('pdfId').touched && form.get('pdfId').invalid" class="text-danger">
        <small *ngIf="form.get('pdfId').errors?.required">PDF şablonu seçimi zorunludur.</small>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="closeModal()">Hayır</button>
  <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="submitForm()">Evet</button>
</div>
